import { Injectable, inject } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { map } from 'rxjs/operators';

import { createEffectFactory } from '@core/ngrx-legacy';

import { PlacementsWithoutOpeningsHttpService } from './placements-without-opening-http.service';
import { PlacementsWithoutOpeningsActions } from './placements-without-openings.store';

@Injectable({
  providedIn: 'root',
})
export class PlacementsWithoutOpeningsEffects {
  private readonly actions$ = inject(Actions);
  private readonly http = inject(PlacementsWithoutOpeningsHttpService);

  public effects = createEffectFactory(PlacementsWithoutOpeningsActions, this.actions$);

  public fetchOne = this.effects(PlacementsWithoutOpeningsActions.fetchOne, ({ payload }) =>
    this.http.fetch$(payload.jobId).pipe(
      map(response => ({
        data: response,
      })),
    ),
  );
}
